import { Component, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { BcMenuModule } from '@bancolombia/design-system-web/bc-menu';
import {
  BcHeaderModule,
} from '@bancolombia/design-system-web/bc-header';
import { BcFloatMenuModule } from '@bancolombia/design-system-web/bc-float-menu';
import { BcAvatarModule } from '@bancolombia/design-system-web/bc-avatar';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { CommonModule } from '@angular/common';
import { filter, Subject, takeUntil } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { BcFooterModule } from '@bancolombia/design-system-web/bc-footer';

@Component({
    selector: 'app-auth-layout',
    imports: [
        BcMenuModule,
        BcHeaderModule,
        BcFloatMenuModule,
        CommonModule,
        BcAvatarModule,
        BcFooterModule,
        RouterModule,
        RouterOutlet,
    ],
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  authService = inject(MsalService);
  msalBroadcastService = inject(MsalBroadcastService);
  ariaLabelogo = 'Bancolombia';
  ariaLabelChannelName = 'Procesos interactivos';
  showMenu = true;
  currentYear = new Date().getFullYear();

  private readonly _destroying$ = new Subject<void>();
  loggedInUserName = '';
  loggedInUserEmail = '';

   ngOnInit() {
    this.authService.handleRedirectObservable().subscribe();
    this.authService.instance.enableAccountStorageEvents();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  nameAbreviation = ''
  checkAndSetActiveAccount() {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount?.name) {
      const nameParts = activeAccount.name.split(' ');
      this.loggedInUserName = nameParts.slice(0, 2).join(' ');
      this.nameAbreviation = nameParts.slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
    }
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      const accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      const activeAccountAll = this.authService.instance.getActiveAccount();
      if (activeAccountAll?.name) {
        const nameParts = activeAccountAll.name.split(' ');
        this.loggedInUserName = nameParts.slice(0, 2).join(' ');
        this.nameAbreviation = nameParts.slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
      }

    }
  }

  logout = () => {
    this.authService.logoutRedirect();
  };

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  footer4 = {
    bottomTextLeftContent: [`Copyright © ${this.currentYear} Grupo Bancolombia.`],
  };
}
